// Centralized data-testid constants for Floreal Atelier
export const TEST_IDS = {
    // Header
    header: 'site-header',
    navHome: 'header-nav-home-link',
    navAtelier: 'header-nav-atelier-link',
    navMatrimoni: 'header-nav-matrimoni-link',
    navWorkshop: 'header-nav-workshop-link',
    navGiardini: 'header-nav-giardini-link',
    navServizi: 'header-nav-servizi-link',
    navGalleria: 'header-nav-galleria-link',
    navEventi: 'header-nav-eventi-link',
    navContatti: 'header-nav-contatti-link',
    navPrenota: 'header-nav-prenota-button',
    headerMenuToggle: 'header-menu-toggle',

    // Footer
    footer: 'site-footer',
    footerInstagram: 'footer-instagram-link',
    footerWhatsapp: 'footer-whatsapp-link',
    footerMaps: 'footer-maps-link',

    // Home hero
    heroSection: 'home-hero',
    heroPrimaryCta: 'home-hero-primary-cta',
    heroSecondaryCta: 'home-hero-secondary-cta',
    heroTertiaryCta: 'home-hero-tertiary-cta',
    homeCardFiori: 'home-service-card-fiori-piante',
    homeCardMatrimoni: 'home-service-card-matrimoni-eventi',
    homeCardWorkshop: 'home-service-card-workshop',
    homeCardGiardini: 'home-service-card-giardini',
    homeCtaInfoCta: 'home-cta-info',
    homeCtaWhatsappCta: 'home-cta-whatsapp',

    // Servizi
    serviziGrid: 'servizi-grid',

    // Gallery
    galleryFilterAll: 'gallery-filter-all',
    galleryGrid: 'gallery-grid',
    galleryItem: 'gallery-item',
    galleryLightbox: 'gallery-lightbox',
    galleryLikeButton: 'gallery-like-button',
    galleryLightboxLikeButton: 'gallery-lightbox-like-button',
    galleryLightboxClose: 'gallery-lightbox-close',

    // Events
    eventCard: 'event-card',
    eventStatusBadge: 'event-status-badge',
    eventSignupButton: 'event-signup-button',
    eventSignupDialog: 'event-signup-dialog',
    eventSignupSubmit: 'event-signup-submit',

    // Booking
    bookingForm: 'booking-form',
    bookingServiceSelect: 'booking-service-select',
    bookingDatePicker: 'booking-date-picker',
    bookingSlotChip: 'booking-slot-chip',
    bookingInspirations: 'booking-inspirations',
    bookingSubmit: 'booking-submit',
    bookingFullName: 'booking-full-name',
    bookingEmail: 'booking-email',
    bookingPhone: 'booking-phone',
    bookingPrivacy: 'booking-privacy',
    bookingNoSlotsWarning: 'booking-no-slots-warning',

    // Contacts
    contactMap: 'contact-map',
    contactWhatsappCta: 'contact-whatsapp-cta',
    contactPhoneLink: 'contact-phone-link',
    contactEmailLink: 'contact-email-link',
    contactInstagramLink: 'contact-instagram-link',
    contactForm: 'contact-form',
    contactFormName: 'contact-form-name',
    contactFormEmail: 'contact-form-email',
    contactFormPhone: 'contact-form-phone',
    contactFormMessage: 'contact-form-message',
    contactFormPrivacy: 'contact-form-privacy',
    contactFormSubmit: 'contact-form-submit',
    contactMapsCta: 'contact-maps-cta',

    // Service detail pages
    pageMatrimoni: 'page-matrimoni',
    pageWorkshop: 'page-workshop',
    pageGiardini: 'page-giardini',

    // Admin
    adminLoginForm: 'admin-login-form',
    adminPasswordInput: 'admin-password-input',
    adminLoginSubmit: 'admin-login-submit',
    adminDashboard: 'admin-dashboard',
    adminTabs: 'admin-tabs',
    adminAppointmentsTable: 'admin-appointments-table',
    adminEventsTable: 'admin-events-table',
    adminSignupsTable: 'admin-signups-table',
    adminWorkshopSignups: 'admin-workshop-signups',
    adminWorkshopViewToggle: 'admin-workshop-view-toggle',
    adminWorkshopAccordion: 'admin-workshop-accordion',
    adminWorkshopGroup: 'admin-workshop-group',
    adminWorkshopTable: 'admin-workshop-table',
    adminWorkshopPaymentSelect: 'admin-workshop-payment-select',
    adminWorkshopNotesButton: 'admin-workshop-notes-button',
    adminWorkshopNotesSave: 'admin-workshop-notes-save',
    adminWorkshopSummaryTable: 'admin-workshop-summary-table',
    adminWorkshopFilterWorkshop: 'admin-workshop-filter-workshop',
    adminWorkshopFilterDate: 'admin-workshop-filter-date',
    adminWorkshopFilterPayment: 'admin-workshop-filter-payment',
    adminWorkshopFilterName: 'admin-workshop-filter-name',
    adminWorkshopExport: 'admin-workshop-export',
    adminWorkshopExportGroup: 'admin-workshop-export-group',
    adminEventType: 'admin-event-type',
    adminEventDeposit: 'admin-event-deposit',
    adminEventPaymentInstructions: 'admin-event-payment-instructions',
    adminEventDocUpload: 'admin-event-doc-upload',
    adminEventDocRemove: 'admin-event-doc-remove',
    adminTabEmail: 'admin-tab-email',
    adminEmailSubject: 'admin-email-subject',
    adminEmailPreview: 'admin-email-preview',
    adminEmailSave: 'admin-email-save',
    adminGalleryTable: 'admin-gallery-table',
    adminMessagesTable: 'admin-messages-table',
    adminFeaturedPanel: 'admin-featured-panel',
    adminFeaturedSlotRow: 'admin-featured-slot-row',
    adminFeaturedSlotSelect: 'admin-featured-slot-select',
    adminFeaturedSlotSave: 'admin-featured-slot-save',
    adminFeaturedSlotClear: 'admin-featured-slot-clear',
};
